import axios from "../utils/axios.wrapper";

// Get all order statuses (for dropdowns)
export const getOrderStatuses = async () => {
  const { data } = await axios.get("/status");
  return data.items || data;
};

// Get active order statuses
export const getActiveOrderStatuses = async () => {
  const { data } = await axios.get("/status/active");
  return data.items || data;
};

// Get order status by ID
export const getOrderStatusById = async (id) => {
  const { data } = await axios.get(`/status/${id}`);
  return data;
};

export const orderStatusService = {
  getOrderStatuses,
  getActiveOrderStatuses,
  getOrderStatusById,
};
